export default {
  label: "En Desarrollo",
  notAvailable: "no disponible",
};
